// Import of the module

import { formatNumber, parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type Permission = {
  id: number;
  status: number;
  max_issuer_count: number;
  strategy: string;
  company?: string;
  start_date?: string;
  end_date?: string;
};

// Definition of the columns

export const permissions_columns: ColumnDef<Permission>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const value = row.getValue("status");
      return <span>{String(value || "")}</span>;
    },
  },
  {
    accessorKey: "max_issuer_count",
    header: () => <div className="text-right">Max Issuer Count</div>,
    cell: ({ row }) => (
      <div className="text-right">
        {formatNumber(row.getValue("max_issuer_count"))}
      </div>
    ),
  },
  {
    accessorKey: "strategy",
    header: "Strategy",
    cell: ({ row }) => <span>{row.getValue("strategy")}</span>,
  },
  {
    accessorKey: "company",
    header: "Company",
    cell: ({ row }) => <span>{row.getValue("company")}</span>,
  },
  {
    accessorKey: "start_date",
    header: "Start Date",
    cell: ({ row }) => parseDate(row.getValue("start_date")),
  },
  {
    accessorKey: "end_date",
    header: "End Date",
    cell: ({ row }) => parseDate(row.getValue("end_date")),
  },
];
